import { render, staticRenderFns } from "./PolicyLogs.vue?vue&type=template&id=d04bff9a"
import script from "./PolicyLogs.vue?vue&type=script&lang=js"
export * from "./PolicyLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports